module.exports = __webpack_public_path__ + "static/media/ms_dos.84f6caef.ico";